import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import WhatsAppFab from "@/components/WhatsAppFab";
import LanguageWelcomeBanner from "@/components/LanguageWelcomeBanner";
import PromoBanner from "@/components/PromoBanner";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Products from "@/pages/Products";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Sectors from "@/pages/Sectors";
import SectorDetail from "@/pages/SectorDetail";
import Freight from "@/pages/Freight";
import Tracking from "@/pages/Tracking";
import Transfer from "@/pages/Transfer";
import Study from "@/pages/Study";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Protected({ children, adminOnly = false }) {
  const { user, bootstrapped } = useAuth();
  const loc = useLocation();
  if (!bootstrapped || user === null) return <div className="min-h-[60vh] flex items-center justify-center text-[var(--ink-soft)]">Chargement…</div>;
  if (user === false) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}

function Shell() {
  return (
    <>
      <AnalyticsTracker />
      <PromoBanner />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/secteurs" element={<Sectors />} />
          <Route path="/secteurs/:slug" element={<SectorDetail />} />
          <Route path="/fret" element={<Freight />} />
          <Route path="/suivi" element={<Tracking />} />
          <Route path="/transfert" element={<Transfer />} />
          <Route path="/etudes" element={<Study />} />
          <Route path="/produits" element={<Products />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <ChatWidget />
      <WhatsAppFab />
      <LanguageWelcomeBanner />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <AuthProvider>
          <Shell />
        </AuthProvider>
      </LangProvider>
    </BrowserRouter>
  );
}
